/**
 * The Studio's page header: title and one supporting line.
 *
 * Shared by /create, /library and the other workspace-adjacent routes so those screens
 * open the same way. It is deliberately quiet — the Studio is a workspace, so this is a
 * label for where you are, not a hero banner. All of the visual weight below it belongs
 * to the composer, the library and the tools.
 *
 * The old header-level credit readout has been removed so the workspace stays focused on
 * the creative task. Account usage is shown centrally in Settings.
 */
import { SectionHeading } from '../ui';

export interface StudioHeaderProps {
  /**
   * Page title. "Studio" on the composer, "Library" on the tracks and playlists
   * screens, "Lyrixa Studio" on the Studio's entry screen. It is also the route's
   * accessible <h1> name.
   */
  title: string;
  subtitle: string;
}

export default function StudioHeader({ title, subtitle }: StudioHeaderProps) {
  return <SectionHeading as="h1" title={title} subtitle={subtitle} marginBottom={20} />;
}
